import { render, staticRenderFns } from "./new-page-not-found.vue?vue&type=template&id=a98c7670&"
import script from "./new-page-not-found.vue?vue&type=script&lang=js&"
export * from "./new-page-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports